import React from 'react';
import { Badge } from '@nicheinc/campus-ds';

import { TableMapperType } from '../../types';

type PropsType = {
	mapperField: TableMapperType;
	item: any;
};

function BadgeCell({ mapperField, item }: PropsType) {
	const badgeData =
		mapperField?.badge &&
		(typeof mapperField.badge === 'function'
			? mapperField.badge(item)
			: mapperField.badge);

	const badgeId =
		typeof badgeData?.id === 'function' ? badgeData?.id(item) : badgeData?.id;

	const badgeIconName =
		typeof badgeData?.icon === 'function'
			? badgeData?.icon(item)
			: badgeData?.icon;

	const badgeVariant =
		typeof badgeData?.variant === 'function'
			? badgeData?.variant(item)
			: badgeData?.variant;

	const badgeText =
		typeof badgeData?.text === 'function'
			? badgeData?.text(item)
			: badgeData?.text;

	const badgeIconWeight =
		typeof badgeData?.iconWeight === 'function'
			? badgeData?.iconWeight(item)
			: badgeData?.iconWeight;

	const badgeTextMaxLength = mapperField?.badgeTextMaxLength || 20;

	const badgeCounter =
		typeof badgeData?.counter === 'function'
			? badgeData?.counter(item)
			: badgeData?.counter;

	const iconBadge =
		typeof badgeData?.iconBadge === 'function'
			? badgeData?.iconBadge(item)
			: badgeData?.iconBadge;

	const ariaLabel =
		typeof badgeData?.ariaLabel === 'function'
			? badgeData?.ariaLabel(item)
			: badgeData?.ariaLabel;

	const dataTestId =
		typeof badgeData?.dataTestId === 'function'
			? badgeData?.dataTestId(item)
			: badgeData?.dataTestId;

	const badgeTooltipProps =
		typeof badgeData?.tooltipProps === 'function'
			? badgeData?.tooltipProps(item)
			: badgeData?.tooltipProps;

	const badgePopOverProps =
		typeof badgeData?.popOverProps === 'function'
			? badgeData?.popOverProps(item)
			: badgeData?.popOverProps;

	const badgeFontWeight =
		typeof badgeData?.fontWeight === 'function'
			? badgeData?.fontWeight(item)
			: badgeData?.fontWeight;

	const badgeIconPosition =
		typeof badgeData?.iconPosition === 'function'
			? badgeData?.iconPosition(item)
			: badgeData?.iconPosition;

	const truncateText = (text?: string) => {
		if (text && text.length > badgeTextMaxLength) {
			return `${text.substring(0, badgeTextMaxLength).trim()}...`;
		}
		return text;
	};

	return (
		<>
			{badgeData && (badgeText || badgeIconName) && (
				<Badge
					id={badgeId}
					iconBadge={!badgeText || iconBadge}
					text={truncateText(badgeText)}
					size={badgeData?.size}
					iconName={badgeIconName}
					variant={badgeVariant}
					iconWeight={badgeIconWeight}
					squared={badgeData?.squared}
					onClick={badgeData?.onClick}
					onRemove={badgeData?.onRemove}
					counter={badgeCounter}
					tooltipProps={badgeTooltipProps}
					popOverProps={badgePopOverProps}
					ariaLabel={ariaLabel}
					dataTestId={dataTestId}
					fontWeight={badgeFontWeight}
					iconPosition={badgeIconPosition}
				/>
			)}
		</>
	);
}

export default BadgeCell;
